// extracted by mini-css-extract-plugin
module.exports = {"modalTitle":"ExportProjectAsDocxDialog_modalTitle_Jc2Cd","title":"ExportProjectAsDocxDialog_title_1QL9h","spinAround":"ExportProjectAsDocxDialog_spinAround_2-Bwm"};